import { useSearch } from "wouter";
import { Seo } from "@/components/Seo";
import { Section, PageHeader } from "@/components/Section";
import { LegalProse } from "@/components/LegalProse";
import {
  CURRENT_LEGAL_VERSION,
  getLegalVersion,
  listLegalVersions,
} from "./versions";

export default function Terms() {
  const search = useSearch();
  const requested = new URLSearchParams(search).get("v");
  const { entry, isCurrent, isKnown } = getLegalVersion(requested);
  const Body = entry.Terms;
  const path = isCurrent ? "/legal/terms" : `/legal/terms?v=${entry.version}`;
  const lede = isCurrent
    ? `Last updated ${entry.lastUpdatedLabel}. These terms govern your access to and use of the FortifyID platform.`
    : `Archived version published ${entry.lastUpdatedLabel}. This is a historical copy preserved for clients who accepted this version. The current Terms are at /legal/terms.`;

  return (
    <>
      <Seo
        title={isCurrent ? "Terms of Service" : `Terms of Service (${entry.version})`}
        description="The terms governing your use of the FortifyID platform."
        path={path}
      />
      <Section>
        <PageHeader
          eyebrow={
            isCurrent
              ? "Legal · Terms of Service"
              : `Legal · Terms of Service · Archived ${entry.version}`
          }
          title="Terms of Service"
          lede={lede}
        />
        <LegalProse>
          {requested && !isKnown ? (
            <p>
              <em>
                The Terms version <code>{requested}</code> is not in our
                archive. Showing the current version ({CURRENT_LEGAL_VERSION})
                instead.
              </em>
            </p>
          ) : null}
          <Body />
          <hr />
          <p className="text-sm">
            <strong>Version archive.</strong> Every published version of these
            Terms is preserved here so anyone who accepted an earlier copy can
            review the exact wording they agreed to:
          </p>
          <ul className="text-sm">
            {listLegalVersions().map((v) => (
              <li key={v.version}>
                <a href={`/legal/terms?v=${v.version}`}>
                  {v.version} — published {v.lastUpdatedLabel}
                </a>
                {v.version === CURRENT_LEGAL_VERSION ? " (current)" : null}
              </li>
            ))}
          </ul>
        </LegalProse>
      </Section>
    </>
  );
}
